export function getGAClientId() {
  try {
    if (typeof document === 'undefined' || !document.cookie) return null;

    const gaCookie = document.cookie
      .split(';')
      .map((cookie) => cookie.trim())
      .find((cookie) => cookie.startsWith('_ga='));

    if (!gaCookie) return null;

    const [, value] = gaCookie.split('=');
    if (!value) return null;

    const parts = value.split('.');
    return parts.length > 2 ? parts.slice(2).join('.') : null;
  } catch (e) {
    console.log('Something went wrong getting GA client id. ' + e + '.');
  }

  return null;
}

export function getGASessionId() {
  try {
    if (typeof document === 'undefined' || !document.cookie) return null;

    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith('_ga_')) {
        const [, value] = cookie.split('=');
        if (!value) continue;

        const parts = value.split('.');
        if (parts && parts.length > 2) {
          const sessionID = parts[2];
          if (!sessionID) continue;

          if (sessionID[0] === 's') return sessionID.substring(1, 11);
          return sessionID;
        }
      }
    }
  } catch (e) {
    console.log('Something went wrong getting GA session id. ' + e + '.');
  }

  return null;
}
